import { DropDownIcon } from 'app/common/presentation/icons'
import { getInitials } from 'app/common/presentation/initials'
import { User, Workspace } from 'app/user/types'

import { Avatar } from 'components'

import styles from './Profile.module.scss'

interface ProfileButtonProps {
  workspace: Workspace
  onClick: () => void
  user: User
}

const ProfileButton = ({ workspace, onClick, user }: ProfileButtonProps) => (
  <div className={styles.profileButton} onClick={onClick}>
    <Avatar initials={getInitials(user)} />
    <div className={styles.workspace}>{workspace.name}</div>
    <DropDownIcon />
  </div>
)

export default ProfileButton
